"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = exports.login = void 0;
const Api = require("../../Api");
const actions = require("./actions");
const login = (dispatch) => {
    return async (jwt) => {
        dispatch(actions.loginRequest(jwt));
        try {
            const payload = await Api.setUpUser(jwt);
            dispatch(actions.loginSuccess(payload));
        }
        catch (error) {
            dispatch(actions.loginFailure(error.message || error));
            return false;
        }
        return true;
    };
};
exports.login = login;
const logout = (dispatch) => {
    return async () => {
        dispatch(actions.logoutRequest());
        try {
            dispatch(actions.logoutSuccess());
        }
        catch (e) {
            dispatch(actions.logoutFailure(e.message || e));
            return false;
        }
        return true;
    };
};
exports.logout = logout;
//# sourceMappingURL=operations.js.map